module.exports = __webpack_public_path__ + "static/solana-poc-2e61b54c72bdc261e675dd81db50e923.jpeg";